import { IObservable, Subject } from '~/rage/utils';
import { IStats } from '~/shared';
import { IStatsService } from './statsServiceTypes';

export class StatsServiceStub implements IStatsService {
	private readonly playTimeStats = new Subject<IStats>({
		daily: 1000000,
		monthly: 10000000,
		yearly: 100000000,
		total: 1000000000,
	});
	private readonly moneySpentStats = new Subject<IStats>({
		daily: 100,
		monthly: 1000,
		yearly: 10000,
		total: 100000,
	});
	private readonly moneyEarnedStats = new Subject<IStats>({
		daily: 100,
		monthly: 1000,
		yearly: 10000,
		total: 100000,
	});

	public async fetchStats(): Promise<void> {
		console.log('fetchStats');
	}

	public getPlayTimeStats(): IObservable<IStats> {
		return this.playTimeStats;
	}

	public getMoneySpentStats(): IObservable<IStats> {
		return this.moneySpentStats;
	}

	public getMoneyEarnedStats(): IObservable<IStats> {
		return this.moneyEarnedStats;
	}
}
